import { ReactGAImplementation } from "react-ga4";

// Use the named constructor rather than the package's CommonJS default export.
// Vite/Rolldown can otherwise expose the module wrapper as the default value,
// leaving methods such as `event` undefined at runtime.
const analytics = new ReactGAImplementation();

export default analytics;
